<template>
  <el-dialog
    title="添加子媒体任务"
    :visible.sync="isShow"
    width="80%"
    center
    @close="$emit('close')"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <div class="add-video-warp-box">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <div class="flex-item">
          <el-form-item label="父媒体ID:" prop="mediaId">
            <el-input v-model="form.mediaId" size="small"></el-input>
            <el-button type="primary" size="small" @click="findFatherInfo()"
              >查询父级媒体</el-button
            >
          </el-form-item>
          <el-form-item label="父媒体标题:" prop="mediaTitle">
            <el-input
              :disabled="true"
              v-model="mediaTitle"
              size="small"
            ></el-input>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="上传类型:" prop="mediaType">
            <el-select
              :disabled="true"
              v-model="form.mediaType"
              size="small"
              placeholder="请选择上传类型"
              clearable
            >
              <el-option value="video" label="视频"></el-option>
              <el-option value="video_adv" label="视频广告"></el-option>
              <el-option value="image" label="漫画"></el-option>
              <el-option value="text" label="小说"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="集数:" prop="episodeNumber">
            <el-input
              :disabled="isPermission"
              v-model.number="form.episodeNumber"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="章节名:" prop="name">
            <el-input
              :disabled="isPermission"
              v-model="form.name"
              size="small"
            ></el-input>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="是否激活:" prop="isActive">
            <el-select
              :disabled="isPermission"
              v-model="form.isActive"
              size="small"
              placeholder="请选择是否激活"
            >
              <el-option :value="true" label="是"></el-option>
              <el-option :value="false" label="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收费类型:" prop="listenPermission">
            <el-select
              :disabled="isPermission"
              v-model="form.listenPermission"
              size="small"
              placeholder="请选择收费类型"
            >
              <el-option :value="0" label="会员"></el-option>
              <el-option :value="1" label="金币"></el-option>
              <el-option :value="2" label="免费"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :disabled="isPermission"
            label="购买价格:"
            prop="price"
            v-if="form.listenPermission == 1"
          >
            <el-input v-model.number="form.price" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item
            label="上传视频:"
            v-if="form.mediaType === 'video' || form.mediaType === 'video_adv'"
          >
            <input
              :disabled="isPermission"
              type="file"
              @change="changeFile"
              accept="video/*"
              id="inputFile"
            />
          </el-form-item>
          <el-form-item
            style="width: 1100px"
            label="上传图集:"
            prop="cover"
            v-if="form.mediaType === 'image'"
          >
            <!--上传图集-->
            <imgs-upload
              :cover="form.cover"
              :action="actionPics"
              @successCallback="successCallbackPic"
              :id="form.sourceID"
              :wSize="180"
              :hSize="320"
              :width="'100px'"
              :height="'100px'"
            ></imgs-upload>
          </el-form-item>
          <el-form-item
            style="width: 1100px"
            label="小说内容:"
            prop="text"
            v-if="form.mediaType === 'text'"
          >
            <!--小说-->
            <el-input
              :disabled="isPermission"
              type="textarea"
              :rows="10"
              placeholder="请输入小说内容"
              v-model="form.text"
            ></el-input>
          </el-form-item>
        </div>
        <div class="flex-item" v-if="form.mediaType === 'text'">
          <!--小说音频上传-->
          <el-upload
            accept="audio/mp3"
            class="upload-demo"
            :action="actionAudio"
            :headers="header"
            :on-success="handleTrialChange"
            :file-list="fileList"
            :limit="1"
          >
            <el-button size="small" type="success" class="uploadMp3"
              >点击上传</el-button
            >
          </el-upload>
        </div>
        <el-form-item class="bottomBtn">
          <el-button
            :disabled="isPermission"
            type="primary"
            size="small"
            @click="submitDate"
            >立即添加</el-button
          >
          <el-button size="small" @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { validatorIndex } from "@/utils/validator";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import API from "@/api";
export default {
  props: ["isShow"],
  data() {
    return {
      isPermission: true,
      SeriesCover: [],
      trackId: "",
      show: false,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      //图集上传
      actionPics: baseConfig.baseServerUrl + "/vid/uploadStaticBatch",
      // 视频播放地址
      videoBaseUrl: baseConfig.playVideoUrl,
      // 音频上传地址
      actionAudio: baseConfig.baseServerUrl + "/vid/upload/audio",
      header: {
        Authorization: local.get("userInfo").token,
      },
      isFree: true,
      flag: false,
      player: "",
      files: null,
      // 表单数据
      mediaTitle: "", //父级媒体标题
      form: {
        mediaId: "", //父级媒体id
        mediaType: "video", //上传文件类型
        episodeNumber: "", // 第几集
        listenPermission: 0, // 收听权限  0:会员   1:金币购买 2:免费
        price: 0, // 价格
        name: "", // 章节名
        text: "", // 小说专用
        audioUrl: "", // 小说专用
        md5: "", // 媒体md5
        sourceID: "", // 视频唯一id,对应文件服
        videoUrl: "",
        filename: "",
        isActive: false, //是否激活
        urlSet: [], // 图集
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        mediaType: [
          { required: true, message: "请选择上传类型", trigger: "blur" },
        ],
        mediaId: [
          { required: true, message: "请输入父级媒体ID", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入章节名", trigger: "blur" }],
        price: [{ required: true, message: "请输入购买价格", trigger: "blur" }],
        text: [{ required: true, message: "请输入小说内容", trigger: "blur" }],
        episodeNumber: [
          { required: true, message: "请输入集数", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    // console.log('创建')
  },
  methods: {
    changeFile(event) {
      let files = event.target.files[0];
      this.files = files;
    },
    cancel() {
      this.cleanForm();
      this.$emit("close");
    },
    findFatherInfo() {
      if (this.form.mediaId === undefined || this.form.mediaId === "") {
        this.$message.error("请输入父级媒体id");
        return false;
      }
      API.getMediaInfo({ id: this.form.mediaId })
        .then((res) => {
          if (res.code === 200 && res.data) {
            console.log(res.data);
            if (res.data.isExist === true) {
              this.isPermission = false;
              this.form.mediaType = res.data.mediaType;
              this.mediaTitle = res.data.mediaTitle;
            } else {
              this.$message.error("父级媒体不存在");
              return false;
            }
          }
        })
        .catch(() => {
          this.isPermission = true;
        });
    },
    // 处理音频
    handleTrialChange(res) {
      if (res.data.code === 200) {
        this.form.audioUrl = res.data.data.fileName;
      } else {
        this.fileList = [];
      }
    },
    // 提交验证
    submitDate() {
      if (this.form.mediaType === "video" && !this.files) {
        this.$message.error("请选择视频");
        return false;
      }
      if (this.form.mediaType === "image" && this.form.urlSet.length <= 0) {
        this.$message.error("请选择漫画图集");
        return false;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = {
            files: this.files || null,
            form: this.form,
            time: new Date().getTime(),
          };
          this.$emit("addTaskSuccess", data);
          this.$emit("close");
          this.cleanForm();
        } else {
          return false;
        }
      });
    },
    cleanForm() {
      this.files = null;
      let dom = document.querySelector("#inputFile");
      if (dom) {
        dom.value = "";
      }
      this.isPermission = true;
      this.mediaTitle = "";
      this.form = {
        mediaId: this.form.mediaId, //父级媒体id
        mediaType: "video", //上传文件类型
        episodeNumber: 1, // 第几集
        listenPermission: 0, // 收听权限  0:会员   1:金币购买 2:免费
        price: 0, // 价格
        name: "", // 章节名
        text: "", // 小说专用
        md5: "", // 媒体md5
        sourceID: "", // 视频唯一id,对应文件服
        videoUrl: "",
        filename: "",
        isActive: false, //是否激活
        urlSet: [], // 图集
      };
    },
    // 封面图上传成功回调
    successCallbackHeng(res) {
      this.form.horizontalCover = res.data.coverImg;
    },
    successCallbackShu(res) {
      this.form.verticalCover = res.data.coverImg;
    },
    // 封面图上传成功回调
    successCallbackPic(seriesCover) {
      this.form.urlSet = seriesCover;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-video-warp-box {
  /deep/ .el-select--small {
    width: 250px !important;
  }
  .bottomBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 14px;
  }
  .flex-item {
    width: 90%;
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .el-upload .el-upload--picture-card {
    width: 100px;
    height: 100px;
  }
  .el-textarea {
    width: 500px;
  }
  .el-input {
    width: 250px;
  }
  .uploader-drop {
    background: none;
    border-radius: 5px;
    border: none;
    padding: 0;
  }
  .uploader-file {
    border-bottom: 1px dashed #ccc;
  }
  .uploader-btn {
    background: #e63765;
    color: white;
    padding: 5px 10px;
    font-size: 13px;
    border: none;
    border-radius: 3px;
    &:hover {
      background: #eb5f84;
    }
  }
  .title {
    width: 100%;
    height: 30px;
    display: inline-block;
    font-size: 14px;
    line-height: 30px;
    overflow: hidden;
    color: #666;
    margin-bottom: 15px;
    cursor: pointer;
    i {
      &:hover {
        color: #e63765;
      }
    }
    span {
      margin-left: 10px;
    }
  }
  .upload-video {
    width: 300px !important;
    .circle-bar {
      width: 100%;
      height: 100%;
      text-align: center;
      .el-progress-circle {
        margin: 0 auto;
        margin-top: 8px;
      }
    }
    .video-box {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
.show {
  left: 20px;
  transition: left 0.2s linear;
}
.upload-demo {
  display: flex;
  margin: 0 0 0 50px;
}
</style>
